// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__ChRMX","loader_animation":"Loader_loader_animation__l3Rz8"};